import { Offices } from "../containers/Offices";
export const OfficesPage = () => (
    <Offices/>
)